// AI Generated: Redux slice for Home page state
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IHomeState } from '$ind/interfaces/home.interface';

export const homeInitialState: IHomeState = {
  stats: {
    operatorsOnboarded: '',
    uniqueCustomers: '',
    marketShare: '',
    totalMarketValue: '',
  },
  testimonials: [],
  faqs: [],
  partners: [],
  loading: false,
  error: null,
};

const homeSlice = createSlice({
  name: 'home',
  initialState: homeInitialState,
  reducers: {
    setStats: (state, action: PayloadAction<any>) => {
      state.stats = action.payload;
    },
    setTestimonials: (state, action: PayloadAction<any[]>) => {
      state.testimonials = action.payload;
    },
    setFaqs: (state, action: PayloadAction<any[]>) => {
      state.faqs = action.payload;
    },
    setPartners: (state, action: PayloadAction<any[]>) => {
      state.partners = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    clearHomeData: (state) => {
      return homeInitialState;
    },
  },
});

export const {
  setStats,
  setTestimonials,
  setFaqs,
  setPartners,
  setLoading,
  setError,
  clearHomeData,
} = homeSlice.actions;

export default homeSlice.reducer;
// AI Generated: End of home slice




